module.exports = __webpack_public_path__ + "static/media/spinner-sml--fast.74caa9eb.svg";